import { render } from "./Map-modal.vue?vue&type=template&id=222448b9"
import script from "./Map-modal.vue?vue&type=script&lang=js"
export * from "./Map-modal.vue?vue&type=script&lang=js"

import "./Map-modal.vue?vue&type=style&index=0&id=222448b9&lang=scss"

import exportComponent from "C:\\Users\\mm\\Documents\\__Kundenprojekte\\ÜIM-HAB\\Entwicklung\\Frontend\\uebersetzen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__